export class SelfExclusionHelper {
  /** calculate time time stamp to be sent for self exclusion */
  static calculateSelfExclusionTimePeriod(selectedTimePeriod: string) {
    const now = Date.now();
    const timePeriods = {
      sixMonths: now + 6 * 30 * 24 * 60 * 60 * 1000, // 6 months in milliseconds
      oneYear: now + 12 * 30 * 24 * 60 * 60 * 1000, // 1 year in milliseconds
      fiveYears: now + 5 * 12 * 30 * 24 * 60 * 60 * 1000, // 5 years in milliseconds
      permanent: now + 1000 * 12 * 30 * 24 * 60 * 60 * 1000, // 1000 years in milliseconds
    };

    return timePeriods[selectedTimePeriod] || 0;
  }
}
